v-row
  v-col(cols="12" md="12")
    colored-radio-group(
      v-model="incident.confirmed"
      :label="label"
      inline
      :rules="[incident.validCheck('confirmed')]"
    )
      v-radio(
        :label="$t('common.yes')"
        :value="true"
      )
      v-radio(
        :label="$t('common.no')"
        :value="false"
      )
  if incident.confirmed
    v-col(cols="12" md="12")
      v-text-field(
        v-model="incident.when"
        :label="$t('patient.medicalHistory.when')"
        :rules="[incident.validCheck('when')]"
      )
